import { render } from "./channel.vue?vue&type=template&id=603e8da0&scoped=true&ts=true"
import script from "./channel.vue?vue&type=script&lang=ts"
export * from "./channel.vue?vue&type=script&lang=ts"

import "./channel.vue?vue&type=style&index=0&id=603e8da0&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603e8da0"]])

export default __exports__